import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export type GenericModalProps = {
  show: boolean;
  onHide: () => void;
  title: string;
  message: ReactNode;
  closeText?: string;
  loading?: boolean;
};

export const GenericModal = ({
  show,
  onHide,
  title,
  message,
  closeText = 'Close',
  loading = false,
}: GenericModalProps) => (
  <Dialog open={show} onClose={onHide} className="relative z-50">
    <div className="fixed inset-0 bg-black/50" aria-hidden="true" />

    <div className="fixed inset-0 flex items-center justify-center p-4">
      <DialogPanel
        className={twMerge(
          'w-full rounded-2xl bg-white text-center shadow-xl',
          loading
            ? 'max-w-[360px] px-5 py-6 md:px-6 md:py-7'
            : 'max-w-[660px] px-6 py-8 md:px-10 md:py-9',
        )}
      >
        <DialogTitle
          className={twMerge(
            'font-normal text-[#292d32]',
            loading ? 'text-xl md:text-2xl' : 'text-3xl',
          )}
        >
          {title}
        </DialogTitle>

        {loading && (
          <div
            className="mx-auto mt-6 size-9 animate-spin rounded-full border-4 border-[#ffbf00] border-r-transparent"
            aria-label="Loading"
            role="status"
          />
        )}

        <div
          className={twMerge(
            'text-[#292d32]',
            loading
              ? 'mt-4 text-sm md:text-base'
              : 'mt-6 text-2xl',
          )}
        >
          {message}
        </div>

        <button
          type="button"
          onClick={onHide}
          className={twMerge(
            'rounded-xl bg-[#ffbf00] font-normal text-black hover:bg-[#eaae00] focus:outline-none focus:ring-2 focus:ring-[#ffbf00] focus:ring-offset-2',
            loading
              ? 'mt-6 px-4 py-2 text-sm'
              : 'mt-14 px-6 py-4 text-2xl',
          )}
        >
          {closeText}
        </button>
      </DialogPanel>
    </div>
  </Dialog>
);
